module.exports = __webpack_public_path__ + "static/media/startgame.73a427e0.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/startgame.wav
// module id = 519
// module chunks = 0